import { lazyRouteComponent } from "@tanstack/react-router";
import { BadgeCheck } from "lucide-react";

import type { PageDef } from "@/app/registry";

export const pages: PageDef[] = [
  {
    path: "/app/onboarding",
    title: "SEBI registration",
    raOnly: true,
    // the RA desk's last entry: the register check and the emailed code
    nav: { label: "SEBI registration", icon: BadgeCheck, group: "Practice", order: 30 },
    roles: ["ra"],
    component: lazyRouteComponent(() => import("./OnboardingPage"), "OnboardingPage"),
  },
];
